module.exports = __webpack_public_path__ + "img/icon-logout.7660ea1c.svg";